<template>
  <v-container>
    <v-row>
      <v-col>
        <CompaniesTable></CompaniesTable>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <UsersTable></UsersTable>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <RolesTable></RolesTable>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <EvacuationsTable></EvacuationsTable>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <SessionsTable></SessionsTable>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <APITokensTable></APITokensTable>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CompaniesTable from "./tables/CompaniesTable.vue";
import UsersTable from "./tables/UsersTable.vue";
import RolesTable from "./tables/RolesTable.vue";
import EvacuationsTable from "./tables/EvacuationsTable.vue";
import SessionsTable from "./tables/SessionsTable.vue";
import APITokensTable from "./tables/APITokensTable.vue";
export default {
  name: "GlobalAdministrationDashboard",
  components: {
    UsersTable,
    CompaniesTable,
    RolesTable,
    EvacuationsTable,
    SessionsTable,
    APITokensTable,
  },
  data() {
    return {
      msg: "GlobalAdministrationDashboard",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
